import(/* webpackMode: "eager", webpackExports: ["AppSwitcher"] */ "/vercel/path0/apps/web/src/features/app-config/components/AppSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useAppConfiguration"] */ "/vercel/path0/apps/web/src/features/app-config/hooks/useAppConfiguration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppConfigProvider"] */ "/vercel/path0/apps/web/src/features/app-config/provider/appConfigProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/vercel/path0/apps/web/src/features/i18n/components/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useTranslation"] */ "/vercel/path0/apps/web/src/features/i18n/hooks/useTranslation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeSwitch"] */ "/vercel/path0/apps/web/src/features/theme/components/ThemeSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/apps/web/src/features/theme/providers/themeProvider.tsx");
